import { PopularDestinations } from 'shared/seo/PopularDestinations';
import { InternalLinksSection } from '@/components/internalLinks/InternalLinksSection';
import { transformDestinations } from '@/components/internalLinks/transformDestinations';
import data from './data/carrental.json';
import { toDestinations } from './toDestinations';

export const CarrentalSeo = () => {
    const countries = toDestinations(data.countries, data.cdnPath, data.basePath, data.altPrefix);
    const europeAccordionItems = transformDestinations(data.europeAccordion, 'leiebil');

    return (
        <>
            <PopularDestinations heading={data.countriesHeadingFrontpage} destinations={countries} />
            <InternalLinksSection title="Finn leiebil i Norge" items={data.norwayAccordion} />
            <InternalLinksSection title="Finn leiebil i Europa" items={europeAccordionItems} />
        </>
    );
};
